/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ThemeOptions } from '@mui/material/styles';

export const CssBaseline: ThemeOptions = {
	components: {
		MuiCssBaseline: {
			styleOverrides: (theme) => `
			${theme.fonts
				.map(
					({ family, style, display, weight, src }) => `
						@font-face {
							font-family: ${family};
							font-style: ${style};
							font-display: ${display};
							font-weight: ${weight};
							src: ${src};
						}
						`
				)
				.join(``)}
            html, #__next { max-width: 100vw; min-height: 100vh; display: flex; flex: 1}
			body { max-width: 100vw; min-height: 100vh; display: flex; flex: 1; overflow-x: hidden; overflow-y: auto !important;}
			#__next {flex-direction: column; }
			#__next > main {flex: 1;}
			img {
				max-width: 100%;
			}
			img[src*="https://tracker.metricool.com/"] {
				display: none;
			}

			nextjs-portal {
				display: none;
			}

			.heading-title {
				margin-bottom: 15px;
				margin-top: 15px;
			}
			
			.heading-title h1 {
				font-size: 18px;
				font-weight: 800;
				text-transform: uppercase;
			}
			
			.heading-title h2 {
				font-size: 18px;
				color: #2b368d;
				border-left: 1px solid #343434;
				padding-left: 13px;
				margin-left: 13px;
				font-size: 1.14em;
				font-weight: 700;
			}

			.heading-title span {
				color: #2b368d;
				border-left: 1px solid #343434;
				padding-left: 13px;
				margin-left: 13px;
				font-size: 1.14em;
				font-weight: 700;
			}

			.heading-title p {
				font-size: 16px;
				font-weight: 400;
				margin-bottom: 15px;
			}

			@media (max-width: 768px) {
				.heading-title {
					display: flex;
					flex-direction: column;
					gap: 3px;
					margin-bottom: 11px;
					margin-top: 11px;
				}
					
				.heading-title h1 {
					font-size: 19px;
				}

				.heading-title h2 {
					font-size: 16px;
					border-left: none;
					margin-left: 0;
					padding-left: 0;
				}

				.heading-title span {
					font-size: 14px;
					border-left: none;
					margin-left: 0;
					padding-left: 0;
				}

				.heading-title p {
					font-size: 14px;
					margin-bottom: 11px;
				}

				.heading-title br {
					display: none;
				}
			}
		
			.tabs-ofertas {
				display: none !important;
			}

			.seoContainer {
				display: block;
				width: 100%;
				font-family: Arial, sans-serif;
				color: #333;
				margin: 0 auto !important;
				max-width: 1200px;
				padding-left: 16px;
				padding-right: 16px;
				box-sizing: border-box;
				display: flex;
				flex-direction: column;
				margin-bottom: 40px !important;
				float: none !important;
				
				@media (min-width: 600px) {
					padding-left: 16px;
					padding-right: 16px;
					margin-bottom: 80px !important;
				}
				@media (min-width: 1200px) {
					max-width: 1280px;
					padding-left: 0px;
					padding-right: 0px;
					margin-bottom: 80px !important;
				}
			}

			.seoContainer h2 {
				font-size: 16px;
				color: #2c2c2c;
				margin-bottom: 10px;
				font-weight: 800;
				text-transform: uppercase;
			}

			.seoContainer h3 {
				font-size: 14px;
				padding: 5px 0px;
				font-weight: 700;
				text-transform: uppercase;
				line-height: 26px;
			}

			.seoContainer p {
				margin: 0;
				font-size: 14px;
				font-weight: 400;
				font-family: Open Sans, "Helvetica Neue", Arial, sans-serif;
				line-height: 1.5;
			}

			.seoContainer p:last-child {
				margin-bottom: 0;
			}

			.seoContainer a {
				color: #007BFF;
				text-decoration: none;
			}

			.seoContainer a:hover {
				text-decoration: underline;
			}
			.banner .title {
				position: absolute;
				left: -80px;
				
			}

			.banner {
				position: relative;
				text-align: center;
				color: white;
			}

			.banner img {
				width: 100%;
				height: auto;
			}

			.banner .row {
				position: absolute;
				top: 50%;
				transform: translate(-50%, -50%);
			}

			.banner .bloque-text {
				
				padding: 10px;
				border-radius: 5px;
			}

			.banner .mobile-hidden {
				display: block;
			}

			.banner .desktop-hidden {
				display: none;
			}

			@media screen and (max-width: 640px) {
				.banner .mobile-hidden {
					display: none;
				}

				.banner .desktop-hidden {
					display: block;
				}
			}

			:root{
				--spacing-1: 4px;
				--spacing-2: 8px;
				--spacing-3: 12px;
				--spacing-4: 16px;
				--spacing-5: 20px;
				--spacing-6: 24px;
				--spacing-7: 32px;
				--spacing-8: 40px;
				--spacing-9: 48px;
				--spacing-10: 56px;
				--spacing-11: 64px;
				--spacing-12: 72px;
				--spacing-13: 80px;
				--spacing-14: 88px;
				--spacing-15: 96px;

				--font-size-biggest: 65px;
				--font-size-display: 40px;
				--font-size-xxl: 30px;
				--font-size-xl: 24px;
				--font-size-lg: 20px;
				--font-size-md: 18px;
				--font-size-sm: 16px;
				--font-size-body: 15px;
				--font-size-default: 14px;
				--font-size-small: 13px;
				--font-size-caption: 12px;
				--font-size-tiny: 11px;
				--font-size-micro: 10px;
			}
            `,
		},
	},
};
